import Feedviews from './Feedviews';

export default Feedviews;
